import { gql } from '@apollo/client';

const STARTER_PACK_FIELDS = gql`
  fragment StarterPackConfigFields on StarterPackConfigEntry {
    id
    enabled
    feature
    triggerType
    triggerLevel
    rewards
    value
    cost
    skuIos
    skuAndroid
    expiryHours
    source
    effectiveLevel
  }
`;

export const GET_STARTER_PACK_CONFIGS = gql`
  ${STARTER_PACK_FIELDS}
  query getStarterPackConfigs {
    liveOps {
      starterPackConfigs {
        ...StarterPackConfigFields
      }
    }
  }
`;

export const UPSERT_STARTER_PACK_CONFIG = gql`
  ${STARTER_PACK_FIELDS}
  mutation upsertStarterPackConfig($input: StarterPackConfigInput!) {
    upsertStarterPackConfig(input: $input) {
      ...StarterPackConfigFields
    }
  }
`;

export const DELETE_STARTER_PACK_CONFIG = gql`
  mutation deleteStarterPackConfig($id: ID!) {
    deleteStarterPackConfig(id: $id)
  }
`;
